const LISTE_COMMANDE_A_FACTURER = {
  actions: {
    facturer: 'Facturer',
    telechargerCommandeSignee: 'Télécharger la commande signée',
  },
  table: {
    code: 'N° commande',
    commercial: 'Commercial',
    assistant: 'Assistant',
    annonceurs: 'Annonceur(s)',
    payeurs: 'Payeur(s)',
    dateCampagne: 'Date de campagne',
    datePrevisualisation: 'Date prev. de facturation',
    etatCommande: 'Etat',
    codeDossier: 'Code dossier',
    montantHtCommande: 'Montant HT total',
    montantHtPeriode: 'Mnt HT à facturer sur période',
    categorieVente: 'Catégorie de vente',
    facture: 'Facturer',
    agence: 'Agence',
    issuRenouvellement: 'Issue renouvel.',
    commentaireInterne: 'Commentaires internes',
    childrow: {
      dateDebut: 'Date début échéance',
      dateFin: 'Date fin échéance',
      typeProduit: 'Type(s) produit',
      patrimoine: 'Patrimoine(s)',
      dateFacturation: 'Date prev de facturation',
      montantHt: 'Montant HT',
      facturationFaite: 'Facturé',
      commentaireFacturation: 'Commentaire',
    },
  },
  factureParEmail: 'Facture par email',
  assistant: 'Assistant(e)',
  commercial: 'Commercial(e)',
};

export default LISTE_COMMANDE_A_FACTURER;
